
import { Component, Input } from '@angular/core'

@Component({
  selector: 'smart-progress',
  templateUrl: './smartProgress.component.pug',
  styleUrls: ['./smartProgress.component.scss'],
})
export class SmartProgressComponent {
  @Input() value: number
  @Input() max: number
  @Input() text: string|undefined
  @Input() maxText: string|undefined
  @Input() animate = false
}
